import type { ReactNode } from "react";

/**
 * Trilho horizontal: uma fila de cartões que rola de lado, com o primeiro
 * alinhado ao gutter e o último respirando antes da borda.
 *
 * É a única rolagem lateral do app fora de tabela, e existe por um motivo:
 * "continue de onde parou" e "para hoje" são vitrines, não listas — a pessoa
 * olha três ou quatro e escolhe, ou ignora e desce. Uma lista vertical dessas
 * seções empurraria a estante inteira para baixo da dobra.
 */
export function Trilho({ children, gap = 14 }: { children: ReactNode; gap?: number }) {
  return (
    <div
      className="flex overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      style={{
        gap,
        paddingLeft: "var(--gutter)",
        paddingRight: "var(--gutter)",
        scrollSnapType: "x proximity",
        scrollPaddingLeft: "var(--gutter)",
      }}
    >
      {children}
    </div>
  );
}
